import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  popupNotificationsQueryKey,
  unreadNotificationsCountQueryKey,
} from "@/lib/constants";
import { guacHttpClient } from "@/lib/http";
import {
  DeleteManyResponse,
  HttpResponse,
  NotificationResponse,
} from "@/types";

export function useDeleteRemoveNotifications() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (notificationIds: number[]) => {
      const res = await guacHttpClient.delete<
        DeleteManyResponse,
        HttpResponse<DeleteManyResponse>
      >("notification-recipients", { data: { notificationIds } });
      return res.data;
    },
    onSuccess: (_, notificationIds) => {
      const deletedIds = new Set(notificationIds);
      const cachedNotifications = queryClient.getQueryData<
        NotificationResponse[]
      >(["notifications"]);
      const hadUnread = Boolean(
        cachedNotifications?.some(
          (notification) =>
            deletedIds.has(notification.id) && !notification.readAt,
        ),
      );

      queryClient.setQueryData<NotificationResponse[]>(
        ["notifications"],
        (cachedData) =>
          cachedData?.filter(
            (notification) => !deletedIds.has(notification.id),
          ),
      );

      queryClient.setQueryData<NotificationResponse[]>(
        popupNotificationsQueryKey,
        (cachedData) =>
          cachedData?.filter(
            (notification) => !deletedIds.has(notification.id),
          ),
      );

      if (hadUnread) {
        void queryClient.invalidateQueries({
          queryKey: unreadNotificationsCountQueryKey,
        });
      }
    },
  });
}
